export default {
  MY_PROFILE: `My Profile`,
  CONTACT_INFO: {
    TITLE: `My Contact Information`,
    SUMMARY: `This information is used to send you bulletins, shift notifications, shift offers, and more.`
  },
  LOGIN_INFO: {
    TITLE: `My Login Information`,
    SUMMARY: `This section lets you edit your login info for the web application, the mobile application and the interactive voice system.`
  },
  DELETE_BUTTON: {
    TITLE: `Delete profile picture`,
    SUMMARY: `Are you sure you want to delete this picture?`,
    PRIMARY_ACTION: `Delete the picture`
  },
  MY_PASSWORD_AND_PHONEPIN: `My Password / Phone PIN`,
  MY_EMAILS: `My Emails`,
  ADD_EMAIL: `Add email`,
  MY_PHONE_NUMBERS: `My Phone Numbers`,
  ADD_PHONE_NUMBER: `Add phone number`,
  EDIT_EMAILS: `Edit email`,
  EDIT_PHONE_NUMBERS: `Edit phone numbers`,
  MISSING_CONTACT_INFO: `You are missing either a phone number or an email, this might prevent you from receiving important messages in the future.`,
  CHANGE_USERNAME: `Change username`,
  CHANGE_PASSWORD: `Change password`,
  CHANGE_PIN: `Change phone pin`,
  USERNAME: {
    LABEL: `Username`,
    PLACEHOLDER: `Enter the desired username`,
    DESCRIPTION: ``
  },
  CONFIRMUSERNAME: {
    LABEL: `Username confirmation`,
    PLACEHOLDER: `Enter the desired username again`,
    DESCRIPTION: ``
  },
  ACTUALPASSWORD: {
    LABEL: `Current password`,
    PLACEHOLDER: `Enter your current password`,
    DESCRIPTION: ``
  },
  PASSWORD: {
    PLACEHOLDER: `Enter your new password`,
    LABEL: `New password`,
    DESCRIPTION: `Your password must be at least 8 and at most 64 characters long`
  },
  CONFIRMPASSWORD: {
    LABEL: `Password confirmation`,
    PLACEHOLDER: `Enter your new password again`,
    DESCRIPTION: ``
  },
  PIN: {
    LABEL: `Phone PIN`,
    PLACEHOLDER: `Enter your new PIN`,
    DESCRIPTION: ``
  },
  CONFIRMPIN: {
    LABEL: `Phone PIN confirmation`,
    PLACEHOLDER: `Enter your new PIN again`,
    DESCRIPTION: ``
  },
  ADDRESS: {
    LABEL: `Email address`,
    PLACEHOLDER: `Enter your email address`,
    DESCRIPTION: ``
  },
  TYPE: {
    LABEL: `Type`,
    PLACEHOLDER: ``,
    DESCRIPTION: ``
  },
  PHONENUMBER: {
    LABEL: `Phone number`,
    PLACEHOLDER: `Enter your phone number`,
    DESCRIPTION: ``
  },
  CALL: {
    LABEL: `Contact preference`,
    DESCRIPTION: ``
  },
  SMS: {
    LABEL: `Contact preference`,
    DESCRIPTION: ``
  },
  CALL_THEN_SMS: {
    LABEL: `Contact preference`,
    DESCRIPTION: ``
  },
  DO_NOT_USE: {
    LABEL: `Contact preference`,
    DESCRIPTION: ``
  },
  QUIT_PAGE: `The wanted modifications haven't yet been applied, are you sure you want to leave the page?`,
  MANDATORY_USERNAME: `Username field is mandatory.`,
  MANDATORY_CONFIRM_USERNAME: `Username confirmation field is mandatory.`,
  MANDATORY_ACTUAL_PASSWORD: `Current password field is mandatory.`,
  MANDATORY_PASSWORD: `Password field is mandatory.`,
  MANDATORY_CONFIRM_PASSWORD: `Password confirmation field is mandatory.`,
  MANDATORY_PIN: `Phone PIN field is mandatory.`,
  MANDATORY_CONFIRM_PIN: `Phone PIN confirmation field is mandatory.`,
  MANDATORY_ADDRESS: `Email address field is mandatory.`,
  MANDATORY_PHONE_NUMBER: `Phone number field is mandatory.`,
  MANDATORY_TYPE: `Type field is mandatory.`,
  INVALID_LENGTH: `The length of the field is invalid.`,
  INVALID_FORMAT: `The format entered is invalid.`,
  INVALID_EMAIL: `Invalid email address`,
  INVALID_PHONE_NUMBER: `Invalid format: must be 10 digits.`,
  WRONG_PASSWORD: `You entered the wrong password. Please enter your current password in the current password field.`,
  CONFIRMATION_FIELD_MUST_MATCH: `The confirmation field must match the other field`,
  INVALID_PIN_FORMAT: `Must contain between 4 and 8 numericals characters`,
  PASSWORD_REQUIREMENT: `Your password must be at least 8 and at most 64 characters long`,
  ALREADY_IN_USE: `Username is already in use.`,
  MAX_PHONE_NUMBERS_REACHED: `You've reached the limit. Please remove a phone number to be able to add another.`,
  UPDATING_PHONES_DISABLED: `Editing phone numbers has been disabled. Ask your manager if you need to make any changes.`,
  UPDATING_EMAILS_DISABLED: `Editing email has been disabled. Ask your manager if you need to make any changes.`,
  INVALID_CODE: { title: `Invalid validation code`, description: `The code you entered is invalid, Please verify it and submit again.` },
  VERIFICATION_CODE_EXPIRED: { title: `Verification code expired`, description: `The code you entered is expired, please request a new code and try again.` },
  ERROR_DURING_VERIFICATION: { title: `Error during verification`, description: `An error occurred while processing the verification, please try again.` },
  EMAIL_VERIFICATION_FAILED: {
    title: `Email verification failed`,
    description: `An error occurred while sending the verification email, please verify your email address and try again.`
  },
  ERROR_UPDATING_PRONOUNS: { title: `Error updating pronouns`, description: `An error occurred while updating your pronouns, please try again.` },
  SMS_VERIFICATION_FAILED: {
    title: `SMS verification failed`,
    description: `An error occurred while sending the SMS, please verify your phone nunber and try again.`
  },
  ENTER_THE_CONFIRMATION_CODE: `Enter the confirmation code`,
  RESEND_CONFIRMATION_CODE: `Send a new code`,
  YOU_CAN_ADD_ONLY_ONE_NUMBER_AT_A_TIME: `You can only add one number at a time. Please save the current one and open the edit form again to add another.`,
  YOU_CAN_ADD_ONLY_ONE_EMAIL_AT_A_TIME: `You can only add one email at a time. Please save the current one and open the edit form again to add another.`,
  PERSONAL_INFO: {
    TITLE: `My Personal Information`,
    SUMMARY: `This section allows you to view information from your personnel file. If you spot any errors, describe them in the box below and press the "Request Changes" button.`,
    MY_BIRTH_DATE: `My Birth Date`,
    MY_SENIORITY: `My Seniority`,
    MY_DEPARTMENTS: `My Departments`,
    MY_EMERGENCY_CONTACTS: `My Emergency Contacts`,
    MY_HIRING_DATA: `My Hiring Data`,
    permitType: `Permit`,
    employeeType: `Employee Type`,
    contractType: `Contract`,
    REQUESTED_CHANGES: `Requested Changes`,
    REASON_FOR_CHANGES: `Reasons given for changes`,
    CANCEL_CHANGE_REQUEST: `Cancel Change Request`,
    MY_ATTRIBUTES: `My attributes`,
    MY_PRONOUNS: `My pronouns`
  },
  ISVALIDTEXT: {
    LABEL: `Request Changes`,
    PLACEHOLDER: `Enter a description of the changes to be made`,
    DESCRIPTION: `Your manager will have access to this text and will be able to make the required changes.`
  },
  MANDATORY_REASON: `You must give a reason for changes`,
  SWITCH_PROFILE_PICTURE: `Use this email for my profile picture`,
  HOW_TO_EDIT_PROFILE_PICTURE: `You can edit your profile picture on Gravatar`,
  EDIT_MY_ASSIGNABLE_ATTRIBUTES: `Edit my assignable attributes`,
  EDIT_MY_PRONOUNS: `Edit my pronouns`,
  MISSING_PRONOUN: `Please specify a pronoun.`,
  CROP_AND_UPLOAD: `Crop and save`,
  editAttributes: {
    CAN_EDIT_ONLY_SELF_ASSIGNABLE: `You can only edit the attributes marked as self-assignable by your employer.`,
    ATTRIBUTES: {
      TITLE: `Attributes`,
      LABEL: `Attributes`,
      DESCRIPTION: `Add and remove attributes based on your skills and preference.`
    }
  },
  PROFILEPICTUREUPLOAD_MODAL: {
    TITLE: `Edit profile picture`,
    SUMMARY: ''
  }
}
